const BREAKPOINTS = {
  xl: 1920,
  l: 1600,
  m: 1024,
  s: 640,
  xs: 320
};

export { BREAKPOINTS };
